module.exports = __webpack_public_path__ + "media/images/diy/picture_bg-34299743c1a4f1e31e78105fbb522d76.png";